import { connect } from "react-redux";
import { Resource } from "./resource";
import { bindActionCreators } from "redux";
import { fetchResource } from "../../../store/thunks/resources";

const mapStateToProps = state => {
  return {
    uid: state.resourceState.uid,
    title: state.resourceState.title,
    summary: state.resourceState.summary,
    description: state.resourceState.description,
    logo: state.resourceState.logo,
    hero_image_mobile: state.resourceState.hero_image_mobile,
    hero_image_desktop: state.resourceState.hero_image_desktop,
    footer_image_one: state.resourceState.footer_image_one,
    footer_image_two: state.resourceState.footer_image_two,
    footer_image_three: state.resourceState.footer_image_three,
    review: state.resourceState.review,
    faqs: state.resourceState.faqs,
    category: state.resourceState.category,
    url: state.resourceState.url,
    meta_description: state.resourceState.meta_description,
    social_share_image: state.resourceState.social_share_image
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchResource: bindActionCreators(fetchResource, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Resource);
